import { Component, OnInit } from '@angular/core';
import { ThemeService } from '@hyperkit';
@Component({
  standalone: false,
  selector: 'footer-only-layout',
  templateUrl: 'footer-only-layout.component.html',
  styleUrls: ['./footer-only-layout.component.scss'],
})
export class FooterOnlyLayoutComponent implements OnInit {  
  theme = 'light';
  constructor(
        private themeService: ThemeService,
  ) {}  

  ngOnInit(): void {
    this.theme = this.themeService.getTheme();
  }
}